import clsx from 'clsx';
import SpinnerMajorIcon from 'images/icons/SpinnerMajor.svg';
import SpinnerMinorIcon from 'images/icons/SpinnerMinor.svg';
import { variationName } from 'utilities/css';

import styles from './Spinner.module.scss';

type Size = 'large' | 'small';

interface SpinnerProps {
  /** Size of spinner
   * @default 'large'
   */
  size?: Size;
}

export function Spinner({ size = 'large' }: SpinnerProps) {
  const className = clsx(
    styles.Spinner,
    size && styles[variationName('size', size)],
  );

  const iconMarkup =
    size === 'large' ? <SpinnerMajorIcon /> : <SpinnerMinorIcon />;

  return (
    <span className={className}>
      <span className={styles.Icon}>{iconMarkup}</span>
    </span>
  );
}
